import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { of } from 'rxjs';
import { MuiBreadcrumbEntry } from './mui-breadcrumb-entry';
import { MuiBreadcrumbsService } from './mui-breadcrumbs.service';

@Component({
  selector: 'mui-breadcrumb-item',
  template: ''
})
export class MuiBreadcrumbItem implements OnInit {
  @Input() url = '/';
  @Input() label = '';

  constructor(private _route: ActivatedRoute, private _bcs: MuiBreadcrumbsService) {
  }

  ngOnInit(): void {
    // Add entry to breadcrumbs upon initialization of component
    this._bcs.addCustomItem(this.toMuiBreadcrumbEntry());
  }

  private toMuiBreadcrumbEntry(): MuiBreadcrumbEntry {
    return {
      url: this.url,
      label: of(this.label),
      route: this._route
    };
  }
}
